// extracted by mini-css-extract-plugin
module.exports = {"defaultMark":"appear-mark_defaultMark__iiwd8"};